export const WEBSITE_EDITOR_TARGET_SECTION_KEY = 'website-editor-target-section'
